// © Microsoft Corporation. All rights reserved.

import { verticalBrandingFontMap } from "./Constants";

export function defineVerticalHeaderFont() {
    const clientSettings = JSON.parse(document.head.dataset.clientSettings || "{}");
    const verticalKey = clientSettings && (clientSettings.verticalKey || clientSettings.vk);
    const fontMap = verticalBrandingFontMap[verticalKey];

    if (fontMap) {
        const style = document.createElement("style");
        style.setAttribute("type", "text/css");
        style.appendChild(document.createTextNode(`@font-face {font-family:${fontMap.name};font-style: normal;src:url("${fontMap.url}") format('woff2');font-display:swap;}`));

        document.head.appendChild(style);
    }
}